<template>
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-4 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="id"
      />
      <span>Référence</span>
    </div>
    <div class="elem elem--span-5 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="dateEmission"
      />
      <span>Date d'émission</span>
    </div>
    <div class="elem elem--span-5 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="dateReception"
      />
      <span>Date de réception</span>
    </div>
    <div class="elem elem--span-6">
      <span>Emetteur</span>
    </div>
    <div class="elem elem--span-3">
      <span>Montant HT</span>
    </div>
    <div class="elem elem--span-3">
      <span>Montant TTC</span>
    </div>
    <div class="elem elem--span-7 elem--sort">
      <BasicSort
        v-model="modelValue"
        name="statut"
      />
      <span>Statut</span>
    </div>
    <div class="elem elem--span-1"></div>
  </div>
</template>

<script setup lang="ts">
  const modelValue = defineModel<string>()
</script>
